import axios from 'axios'
import { useStore } from '@/store'

const RefreshMessage = {
  template: `
  <div class="pr-8 font-light">
  <p>
  Vestbee has been recently updated.
  Please
  <a href="#" @click="refresh()" class="font-semibold text-gray-700">refresh</a>
   at your first convenience
  </p>
  </div>
  `,
  setup() {
    // this would prevernt from showing this message multiple times
    const store = useStore()
    store.commit('common/markNewVersionAsSeen')

    const refresh = () => {
      document.location.reload(true) // deprecated and might be ignored by some browsers, thus we perform another reload just after it
      document.location.reload()
    }
    return {
      refresh,
    }
  },
}

const FEATURE_ENABLED = false

export default {
  install(Vue, { app, store }) {
    const state = {
      messageAlreadyShown: false,
    }

    axios.interceptors.response.use((response) => {
      const apiVersion = response.headers['api-version']
      const webVersion = response.headers['web-version']

      const appInfo = store.state.common.appInfo
      if (appInfo.version !== webVersion) {
        store.commit('common/setVersion', webVersion)
      }
      if (appInfo.apiVersion !== apiVersion) {
        store.commit('common/setApiVersion', apiVersion)
      }

      const showMessage = () => {
        if (state.messageAlreadyShown) {
          console.log(
            ' ==> wanted to show new version message but it has already been done <==',
          )
          return
        }
        state.messageAlreadyShown = true
        const message = app.$createElement(RefreshMessage)
        app.$message.warning({
          message,
          duration: 0,
          showClose: true,
        })
        console.log(' ==> Show message to refresh page <==')
      }

      if (FEATURE_ENABLED && store.state.common.appInfo.versionHasChanged) {
        showMessage()
      }

      return response
    })
  },
}
